function findIKRoot(entity) {
  while (entity && !(entity.components && entity.components["ik-root"])) {
    entity = entity.parentNode;
  }
  return entity && entity.components["ik-root"];
}

/**
 * Provides access to the end effectors for IK.
 * @namespace avatar
 * @component ik-root
 */
AFRAME.registerComponent("ik-custom-controller", {
  schema: {
    fullBody: { type: "boolean", default: false },
    hasMaleAnim: { type: "boolean", default: false},
  },
  init(){
    this.lockAvatarRotation = false;
    this.ikRoot = findIKRoot(this.el);
    this.camera = this.ikRoot.camera;
  },
  update(oldData){
    if (this.data.fullBody !== oldData.fullBody) {
      this.fullBody = this.data.fullBody
    }

    if (this.data.hasMaleAnim !== oldData.hasMaleAnim)
      this.hasMaleAnim = this.data.hasMaleAnim
  },
  adjustCamera(){
    const {camera} = this.ikRoot;
    if(this.fullBody && !this.hasMaleAnim) {
      camera.object3D.position.y = 1.55;
    } else {
      camera.object3D.position.y = 1.6;
    }

    if(this.lockAvatarRotation) {
      camera.object3D.position.y = 1.68;
      camera.object3D.position.x = 0.03;
      camera.object3D.position.z = 0.03;
    } 
  }
});
